// ============================================================
// PREZENCE — Transparency page ("What we monitor")
// Always available to every employee. Reads the same policy the
// consent screen uses, so it's a single source of truth.
// ============================================================
import React, { useState, useEffect } from 'react';
import api from '../../api/client';
import './transparency.css';

export default function Transparency() {
  const [policy, setPolicy] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get('/consent/policy').then(r => setPolicy(r.data.policy)).catch(() => {});
    api.get('/consent/status').then(r => setStatus(r.data)).catch(() => {});
  }, []);

  if (!policy) return null;

  return (
    <div className="tp-root">
      <div className="tp-header">
        <h1 className="tp-title">What Prezence Monitors</h1>
        <p className="tp-sub">Full transparency about your data — nothing hidden</p>
      </div>

      {status?.consentedAt && (
        <div className="tp-consent-note">
          ✓ You acknowledged this policy (version {status.consentedVersion}) on{' '}
          {new Date(status.consentedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}.
        </div>
      )}

      <p className="tp-intro">{policy.intro}</p>

      <div className="tp-section-label">WHAT IS COLLECTED</div>
      <div className="tp-items">
        {policy.items.map((it, i) => (
          <div className="tp-item" key={i}>
            <div className="tp-item-title">{it.title}</div>
            <div className="tp-item-detail">{it.detail}</div>
          </div>
        ))}
      </div>

      <div className="tp-section-label">YOUR PROTECTIONS</div>
      <ul className="tp-assurances">
        {policy.assurances.map((a, i) => <li key={i}>{a}</li>)}
      </ul>

      <div className="tp-footer">
        Policy version {policy.version}. Questions about how your data is handled? Reach out to your HR team.
      </div>
    </div>
  );
}
